import React, { useState } from 'react';
import { Modal } from '@material-ui/core';

const maxLengthForTrim = 25;

export default function OnHoldPopup({ params }) {
  const [openModal, setOpenModal] = useState(false);

  const isModal =
    params?.data?.adminFeedback && params?.data?.adminFeedback?.length > 0;

  return (
    <div>
      {isModal ? (
        <div
          className='flex items-center h-full text-blue-600 cursor-pointer'
          onClick={() => {
            if (!isModal) return;
            setOpenModal(true);
          }}
        >
          {params?.data?.adminFeedback[0].substring(0, maxLengthForTrim)}...
        </div>
      ) : (
        '-'
      )}

      {isModal && (
        <Modal
          open={openModal}
          aria-labelledby='modal-modal-title'
          aria-describedby='modal-modal-description'
        >
          <div className='relative overflow-y-auto  top-2 md:top-10 m-auto bg-white  rounded-lg md:px-8 px-3 py-4 z-50 lg:w-1/2 w-11/12 border-solid border border-gray-600'>
            <div
              className='absolute right-2 top-2 cursor-pointer'
              onClick={() => {
                setOpenModal(false);
              }}
            >
              X
            </div>

            <h2 className='font-bold text-center'>On hold reasons</h2>

            <hr />

            <div className='p-2'>
              {params?.data?.adminFeedback.map((item, index) => (
                <div key={index}>
                  {index + 1}. {item}
                </div>
              ))}
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
}
